import React, { FC, useEffect, useState } from 'react';
import { usePageContext } from '../context/pageContext';
import { getRecommendedArticles } from '../../utils/getRecommendedArticles';
import { CardArticle } from './article/cardArticle/CardArticle';
import * as styles from './RecommendedArticlesSection.module.scss';

interface IProps {
  currentArticleId?: string | null;
  experienceType?: string | null;
  pathology?: string | null;
  bodyArea?: string | null;
  sectionTitle?: string | null;
}

const RecommendedArticleSection: FC<IProps> = ({
  experienceType,
  pathology,
  bodyArea,
  currentArticleId,
  sectionTitle,
}) => {
  const { lang } = usePageContext();
  const [recommendedArticles, setRecommendedArticles] = useState<any[]>();

  const indexName = `search-winback_${lang}`;

  useEffect(() => {
    const getRecoArticles = async () => {
      const articles = await getRecommendedArticles({
        pathology,
        bodyArea,
        experienceType,
        excludeId: currentArticleId,
        index: indexName,
      });
      setRecommendedArticles(articles);
    };

    getRecoArticles();
  }, []);

  return (
    <div className={styles.wrapper}>
      {sectionTitle && <h3 className={styles.sectiontitle}>{sectionTitle}</h3>}
      <div className={styles.recommendedArticles}>
        {recommendedArticles?.map((article, index) => {
          return (
            <CardArticle
              key={`${index}-${article?.id}`}
              imageUrl={article._source.img}
              experienceType={article._source.experienceType}
              title={article._source.title}
              slug={article._source.slug}
            />
          );
        })}
      </div>
    </div>
  );
};
export default RecommendedArticleSection;
